<template>
  <v-btn v-bind="$attrs" class="overlay-btn mb-4" @click="displayOverlay">
    <div v-if="props.iconName != null" style="margin-right: 8px;">
      <v-icon size="18">{{ props.iconName }}</v-icon>
    </div>
    {{ props.buttonText }}
  </v-btn>

  <OverlayWindow :isVisible="isOverlayVisible" :overlayTitle="props.windowTitle" :centralizeWindow="props.centralizeWindow"
    @closeOverlay="closeAndEmit">
    <div class="overlay-content">
      <slot @closeOverlay="isOverlayVisible = false"></slot>
    </div>
  </OverlayWindow>
</template>

<script setup>
import { defineOptions, defineProps, defineEmits, defineExpose, ref } from 'vue';
import OverlayWindow from '../OverlayWindow.vue';

defineOptions({
  name: "DisplayOverlayWindowButton",
  inheritAttrs: false
})

const emits = defineEmits([
  'onWindowClosed'
])

const props = defineProps({
  buttonText: String,
  iconName: String,
  windowTitle: String,
  centralizeWindow: {
    type: Boolean,
    default: true
  },
  buttonColor: String
})

const isOverlayVisible = ref(false)

const displayOverlay = () => {
  isOverlayVisible.value = true;
}

const closeWindow = () => {
  isOverlayVisible.value = false;
}

const closeAndEmit = () => {
  emits('onWindowClosed');
  closeWindow();
}

defineExpose({
  closeWindow
})

</script>

<style scoped>
.overlay-content {
  padding: 10px;
}

.overlay-btn {
  background: var(--duallo-accent-gradient);
  color: #071514;
  font-weight: 700;
  border-radius: var(--duallo-radius-sm);
  padding: 10px 20px;
  text-transform: none;
  letter-spacing: 0;
  box-shadow: var(--duallo-shadow-sm);
  transition: filter 0.15s ease;
}

.overlay-btn:hover {
  filter: brightness(1.05);
}
</style>
